module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/Grievances-Addressing/grievence-addressing/grievence-addressing.component.css
// module id = ./src/app/Grievances-Addressing/grievence-addressing/grievence-addressing.component.css
// module chunks = main